// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { DollarSign as RawDollarSign } from "lucide-react";
export const DollarSign = /* @__PURE__ */ createIcon(RawDollarSign, "DollarSign", 2);
